var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.17157 5H5C3.11438 5 2.17157 5 1.58579 5.58579C1 6.17157 1 7.11438 1 9V19C1 20.8856 1 21.8284 1.58579 22.4142C2.17157 23 3.11438 23 5 23H11C12.8856 23 13.8284 23 14.4142 22.4142C15 21.8284 15 20.8856 15 19V10.8284C15 10.4197 15 10.2153 14.9239 10.0315C14.8478 9.84776 14.7032 9.70324 14.4142 9.41421L10.5858 5.58579C10.2968 5.29676 10.1522 5.15224 9.96847 5.07612C9.7847 5 9.58032 5 9.17157 5Z",
    stroke: "#E5E5E5",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 5V9C9 9.94281 9 10.4142 9.29289 10.7071C9.58579 11 10.0572 11 11 11H15",
    stroke: "#E5E5E5",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 0V5L13 5.05441C12.9999 5.47848 12.9998 5.8906 13.0455 6.23052C13.097 6.61372 13.2226 7.051 13.5858 7.41421C13.949 7.77743 14.3863 7.90295 14.7695 7.95447C15.1094 8.00017 15.5215 8.00009 15.9456 8.00001H15.9456L16 8H21V14C21 16.8284 21 18.2426 20.1213 19.1213C19.2426 20 17.8284 20 15 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14V6C5 3.17157 5 1.75736 5.87868 0.87868C6.75736 0 8.17157 0 11 0H13ZM15 0.00462076V5C15 5.49967 15.0021 5.77383 15.0277 5.96402L15.0287 5.97131L15.036 5.97231C15.2262 5.99788 15.5003 6 16 6H20.9954C20.9852 5.58836 20.9525 5.31595 20.8478 5.06306C20.6955 4.69552 20.4065 4.40649 19.8284 3.82843L17.1716 1.17157C16.5935 0.593512 16.3045 0.304482 15.9369 0.152241C15.684 0.0474889 15.4116 0.0148133 15 0.00462076Z",
    fill: "#E5E5E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.9013800beaa97761db6853297afa9850.svg";
export { ForwardRef as ReactComponent };